<template>
    <div class="navbar-wrapper px-4 lg:px-12">
        <nav
            class="navbar h-auto lg:h-16 w-full xl:py-3 items-center justify-between z-10 hidden sm:flex sm:flex-col lg:flex-row">
            <div class="flex items-center h-16 sm:justify-between sm:w-full lg:w-auto">
                <i @click="$router.push('/')"
                   class="cursor-pointer">
                    <img :src="getLogo"
                         alt="Logo"
                         class="h-10">
                </i>
                <IconHorisontalLine class="hidden lg:flex mx-4 xl:mx-12"/>
                <DashboardMenu :editMode="editMode" v-if="layoutType === 'activeLayout'" />
                <ManageReports />
                <i class="vc-icon-home icon-lg text-gray-700 cursor-pointer hover:text-primary" v-if="isReportPage" @click="$router.push('/')" />
            </div>
            <div class="flex items-center p-2 sm:justify-between sm:w-full lg:w-auto">
                <slot name="dashboard-operations"/>
                <div class="flex justify-between w-full items-center" v-if="layoutType === 'activeLayout' || isReportPage">
                    <LanguageSwitcher class="lg:mx-5" />
                    <AccountMenu @currentAccountIdUpdated="currentAccountIdUpdated" />
                </div>
            </div>
        </nav>
    </div>
</template>
<script>
    export default {
        components: {
            AccountMenu: () => import('@/components/Navbar/components/AccountMenu'),
            ManageReports: () => import('@/components/Navbar/components/ManageReports'),
            DashboardMenu: () => import('@/components/Navbar/components/DashboardMenu'),
            LanguageSwitcher: () => import('@/components/Navbar/components/LanguageSwitcher')
        },
        props: {
            editMode: {
                type: Boolean
            },
            layoutType: {
                type: String
            },
            isReportPage: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            getTypeOfLayout () {
                return this.$store.getters['layout/getTypeOfLayout']
            },
            getLogo() {
                return this.$store.getters['layout/getLogo'](this.getTypeOfLayout)
            },
        },
        methods: {
            currentAccountIdUpdated (id) {
                this.$emit('currentAccountIdUpdated', id)
            }
        }
    }
</script>
<style scoped>
.navbar-wrapper {
    @apply flex w-full;
    box-shadow: 0px 0px 5px #E0E2E5;
    background: var(--mainBgColor-color);
}
</style>
